import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DID, VerificationData } from 'voxloud-types/dist/models';

import { DidsService, VerificationDataService } from 'src/app/domains/dids/services';
import { PortabilityRequestDto } from 'src/app/domains/dids/models';

@Component({
  selector: 'gdp-documents-popup',
  templateUrl: './documents-popup.component.html',
  styleUrls: ['./documents-popup.component.scss']
})
export class DocumentsPopupComponent implements OnInit {
  public verificationData: VerificationData;
  public currentLang: string;
  public companyId: any;
  public did: DID;
  public selectedDoc: PortabilityRequestDto;
  public loading: boolean;

  constructor(
    private activeModal: NgbActiveModal,
    private translate: TranslateService,
    private didsService: DidsService,
    private verificationDataService: VerificationDataService
  ) { }

  ngOnInit() {
    this.currentLang = this.translate.currentLang;
    this.getDocuments();
  }

  getDocuments() {
    if (this.did.portability_request_id) {
      this.loading = true;
      this.didsService.getPortabilityDocumentsById(this.did.portability_request_id)
        .subscribe(
          (res: PortabilityRequestDto) => {
            this.selectedDoc = res;
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    }

    if (this.did.verification_data_id) {
      this.loading = true;
      this.verificationDataService.getVerificationDataById(this.did.verification_data_id)
        .subscribe(
          (res: VerificationData) => {
            this.verificationData = res;
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    }
  }

  close() {
    this.activeModal.close();
  }

}
